import closeProjectsComponent from './close-projects.component';

const closeProjectsModule = angular.module('closeProjects', [
])
  .component('closeProjects', closeProjectsComponent)
  .name;

export default closeProjectsModule;
